import styled from 'styled-components'

export const CarouselSection = styled.section`
  max-width: 100%;
  display: flex;
  align-items: center;
  align-self: center;
  margin: 0 auto;
`

export const CarouselWrapper = styled.div`
  max-width: 100%;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    max-width: 394px;
  `}
  ${({ theme }) => theme.mediaWidth.upToSmall`
  width: 100%;
  gap: 20px;
  `}
`
